import React, { useState, useEffect } from 'react';
import { Container, Alert, Spinner, Button } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { authService } from '../services/api';

const VerifyEmailPage = () => {
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  
  const location = useLocation();
  const navigate = useNavigate();
  
  useEffect(() => {
    const verifyEmail = async () => {
      const params = new URLSearchParams(location.search);
      const token = params.get('token');
      
      if (!token) {
        setError('Invalid verification link');
        setLoading(false);
        return;
      }
      
      try {
        await authService.verifyEmail(token);
        setSuccess(true);
        setLoading(false);
      } catch (err) {
        setError(err.response?.data?.message || 'Verification failed. Please try again.');
        setLoading(false);
      }
    };
    
    verifyEmail();
  }, [location]);
  
  return (
    <Container className="mt-5 text-center">
      <h2>Email Verification</h2>
      
      {loading ? (
        <div className="mt-4">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <p className="mt-2">Verifying your email...</p>
        </div>
      ) : success ? (
        <div className="mt-4">
          <Alert variant="success">
            Your email has been successfully verified! You can now login to your account.
          </Alert>
          <Button 
            variant="primary" 
            onClick={() => navigate('/login')}
            className="mt-3"
          >
            Go to Login
          </Button>
        </div>
      ) : (
        <div className="mt-4">
          <Alert variant="danger">
            {error}
          </Alert>
          <Button 
            variant="primary" 
            onClick={() => navigate('/login')}
            className="mt-3"
          >
            Go to Login
          </Button>
        </div>
      )}
    </Container>
  );
};

export default VerifyEmailPage;